// Sortie du navigateur intégré (A12, 06/10/2026) : UNE tentative de rouvrir la
// page dans le vrai navigateur, puis, si on est toujours là après 2 s, l'aide
// « Ouvre avec ton navigateur » (AideNavigateur.vue, montée dans App.vue).
//
// Le claim d'un jeton ATTEND la fin de cette séquence (scanAutorise) : le
// propriétaire d'un jeton est immuable, et un uid de webview est souvent
// effacé à la fermeture. Claimer ici donnerait le jeton à un joueur fantôme,
// pour toujours. Le scan n'est pas bloqué pour autant : l'aide propose
// « Continuer ici » (phase continuer), qui lance le claim.
//
// Anti-boucle : drapeau sessionStorage (même onglet) ET préfixe /nav dans
// l'URL de sortie (nouvel onglet, autre appli : le drapeau n'y est pas).
import { reactive } from "vue";
import {
  navigateurIntegre,
  plateforme,
  marque,
  PREFIXE_SORTIE,
  cheminDeSortie,
  urlDeSortie,
} from "./integre";
import { idDepuisChemin } from "@/modules/scan/jeton";

export const CLE_TENTATIVE = "animax_sortie_tentee";
export const DELAI_AIDE = 2000;

// phase : aucune (vrai navigateur) | tentative | aide | continuer
export const sortie = reactive({ phase: "aucune", lien: "", ios: false, params: null });

export const scanAutorise = () => sortie.phase === "aucune" || sortie.phase === "continuer";

export function demarrerSortie({ ua, location, storage, aller, track, doc, minuterie = setTimeout }) {
  sortie.phase = "aucune";
  if (!navigateurIntegre(ua)) return;

  const params = { platform: plateforme(ua), brand: marque(ua) };
  sortie.params = params;
  sortie.ios = params.platform === "ios";
  const { host, pathname, search, hash } = location;
  const parSortie = pathname.startsWith(PREFIXE_SORTIE + "/");
  const cheminReel = parSortie ? pathname.slice(PREFIXE_SORTIE.length) : pathname;
  const id = cheminReel.startsWith("/tk/") ? idDepuisChemin(cheminReel, search, hash) : "";
  const chemin = cheminDeSortie({ pathname: cheminReel, search, hash }, id || null);
  sortie.lien = `https://${host}${chemin}`;

  let deja = parSortie;
  try {
    deja = deja || storage?.getItem(CLE_TENTATIVE) === "1";
  } catch {
    /* stockage bloqué */
  }
  const url = urlDeSortie(ua, host, chemin);
  if (deja || !url) {
    sortie.phase = "aide";
    track("inapp_browser", { ...params, result: deja ? "already_tried" : "no_escape" });
    return;
  }

  try {
    storage?.setItem(CLE_TENTATIVE, "1");
  } catch {
    /* stockage bloqué : le préfixe /nav reste */
  }
  sortie.phase = "tentative";
  track("inapp_browser", { ...params, result: "attempt" });
  // Page masquée pendant la tentative : le vrai navigateur a pris la main.
  const surMasquage = () => {
    if (doc.visibilityState === "hidden" && sortie.phase === "tentative") {
      doc.removeEventListener("visibilitychange", surMasquage);
      track("inapp_browser", { ...params, result: "left" });
    }
  };
  doc?.addEventListener("visibilitychange", surMasquage);
  aller(url);
  minuterie(() => {
    if (sortie.phase !== "tentative") return;
    sortie.phase = "aide";
    track("inapp_browser", { ...params, result: "stayed" });
  }, DELAI_AIDE);
}

export function continuerIci(track) {
  sortie.phase = "continuer";
  track("inapp_browser", { ...sortie.params, result: "continue_here" });
}
